// extracted by mini-css-extract-plugin
module.exports = {"collapseHeader":"Collapse_collapseHeader__2xzVj","collapseShown":"Collapse_collapseShown__W5vvn","collapseHidden":"Collapse_collapseHidden__1myBr"};